import * as React from "react";
import { UitkFullscreenDialog, UitkDialogAnimationType } from "uitk-react-dialog";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { UitkToolbar, ToolbarType } from "uitk-react-toolbar";
import { TravelersContent } from "./TravelersContent";
import { TravelersDialogProps } from "../typings";

export const TravelersDialog = (props: TravelersDialogProps) => {
  return (
    <QueryRoute query={{ pwaDialog: props.queryRouteId }}>
      <Layer id={`${props.queryRouteId}-dialog`}>
        <UitkFullscreenDialog
          className="GuestDialog uitk-grid uitk-grid-cell all-cell-1-1"
          dialogShow={true}
          animation={UitkDialogAnimationType.SLIDEUP}
        >
          <div key={`${props.queryRouteId}-dialog-toolbar`} className="uitk-cell">
            <UitkToolbar
              action={props.onDismiss}
              iconLabel={props.l10n.formatText(props.config.dialogCancelLabelToken)}
              header={props.l10n.formatText(props.config.dialogTitleToken)}
              type={ToolbarType.CLOSE}
            />
          </div>
          <TravelersContent
            key={`${props.queryRouteId}-dialog-picker`}
            travelers={props.travelers}
            l10n={props.l10n}
            onSave={props.onSave}
            config={props.config}
          />
        </UitkFullscreenDialog>
      </Layer>
    </QueryRoute>
  );
};
